<template>
  <div class="banner">
    <div class="swiper">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, index) in bannerList"
          :key="index"
        >
          <img :src="item.url" alt="" />
        </div>
      </div>
      <div class="swiper-button-prev" v-show="swiperIsHover">
        <img src="@/assets/imgs/left.png" alt="" />
      </div>
      <div class="swiper-button-next" v-show="swiperIsHover">
        <img src="@/assets/imgs/right.png" alt="" />
      </div>

      <div class="swiper-pagination" v-show="swiperIsHover"></div>
    </div>
  </div>
</template>

<script>
import 'swiper/swiper-bundle.min.css' // 所有 Swiper 样式，包括所有模块样式（如导航、分页等）
import Swiper, { Navigation, Pagination, Scrollbar, Autoplay } from 'swiper' // 导入您需要的模块
import { getBanner } from '@/api/home'
export default {
  data() {
    return {
      swiperIsHover: false, //是否显示轮播图的左右按钮和小圆点
      bannerList: [],
    }
  },
  mounted() {
    this.getBanner()
  },
  methods: {
    jump({ realIndex }) {
      let item = this.bannerList[realIndex]
      if (item && item.redirectUrl) {
        location.href = item.redirectUrl
      }
    },
    async getBanner() {
      let data = await getBanner()
      this.bannerList = data
      this.$nextTick(() => {
        let that = this
        // 轮播图
        let swiper = new Swiper('.swiper', {
          speed: 400,
          spaceBetween: 100,
          observer: true,
          observeParents: true,
          loop: true,
          autoplay: {
            delay: 3000,
          },
          // loop: true,
          modules: [Navigation, Pagination, Scrollbar, Autoplay],
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          on: {
            click: this.jump,
          },
        })
        //鼠标覆盖停止自动切换
        swiper.el.onmouseover = function () {
          swiper.autoplay.stop()
          that.swiperIsHover = true
        }

        //鼠标离开开始自动切换
        swiper.el.onmouseout = function () {
          swiper.autoplay.start()
          that.swiperIsHover = false
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
  // height: 440px;
  // height: 580px;
  height: 400px;
  .swiper {
    height: 100%;
    .swiper-slide {
      img {
        width: 100%;
        height: 100%;
        cursor: pointer;
        object-fit: cover;
      }
    }
  }
}
/deep/.swiper-pagination-bullet {
  background: #a6a6a6;
  opacity: 1;
}
/deep/.swiper-pagination-bullet-active {
  background-color: #fff;
}

.swiper-button-prev {
  left: 40px;
}
.swiper-button-prev:after,
.swiper-rtl .swiper-button-next:after {
  content: '';
}
.swiper-button-next {
  right: 40px;
}
.swiper-button-next:after,
.swiper-rtl .swiper-button-prev:after {
  content: '';
}
</style>